module.exports = __webpack_public_path__ + "static/media/PM49.973a4399.png";